class IntoView {

    /**
     * @since 4.7.0
     * @method constructor
     */
    constructor() {
        // Declare and initialize
        this.selector = '[data-into-view]';
        this.flood;

        // Run initialization
        this.init();
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 4.18.0
     * @returns object The initialized map
     */
    init() {
        // If there are no countdowns, bail
        if (!$(this.selector).length) return;

        // Listen for window scroll
        $(window).scroll(() => {

            // If the flood gate is opened, close it
            if (this.flood)
                clearTimeout(this.flood);

            // Open a time-delay floodgate
            this.flood = setTimeout(() => this.toggle(this.selector), 50);

        });

        // Run it one time when the page loads
        this.flood = setTimeout(() => this.toggle(this.selector), 50);

        // Prevent leaks
        return;
    }

    /**
     * Toggle a class when an element scrolls into view.
     *
     * @since 4.18.0
     * @method toggle
     * @param string selector is the element selector
     * @return void
     */
    toggle(selector) {

        // Declare and initialize
        var top    = $(window).scrollTop();
        var bottom = top + $(window).height();

        // Add classes to each of them
        $(selector).each(function () {

            // Declare and initialize
            let ele       = $(this);
            let toggle    = ele.data('into-view') || 'seen';
            let eleTop    = ele.offset().top;
            let eleBottom = eleTop + ele.height();
            let position  = bottom - eleTop;

            // Toggle class based on viewability
            if (bottom >= eleTop && eleBottom >= top)
                ele.addClass(toggle);

        });

    }
}

export default IntoView;